import { render, staticRenderFns } from "./ThreeColumns.vue?vue&type=template&id=4922ba3a&"
import script from "./ThreeColumns.vue?vue&type=script&lang=js&"
export * from "./ThreeColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports